import { useEffect, useState } from "react";
import DerogationCCSandCCU from "./DerogationCCSandCCU";
import DerogationIceClass from "./DerogationIceClass";
import DerogationOMR from "./DerogationOMR";
import DerogationPhaseIn from "./DerogationPhaseIn";
import EmissionReported from "./EmissionReported";
import EmissionsAfterDerogation from "./EmissionsAfterDerogation";
import { Button, Icon } from "abs-ui-components";
import { useSelector } from "react-redux";
import axiosHttp from "../../../../../../services/interceptor";
import EUMRVPortStaysOld from "./EmissionReportedPSOld";
import Loader from "../../../../../../common/Loader/Loader";
import { roundNumericValues } from "../../../../../../common/utils/RoundNumericValues";

const EUMRVPortStays = () => {
	const [isExpanded, setIsExpanded] = useState(false);
	const [data, setEUMRVData] = useState([]);
	const [loading, setLoading] = useState(false);

	const toggleExpandCollapse = () => {
		setIsExpanded((prev) => !prev);
	};

	const reportDetails = useSelector(
		(state) => state.reports.selectedReportDetails
	);

	
	const fetchEUMRVPortStayssData = async () => {
		setLoading(true);
		try {
			const EUMRVPortStaysData = await axiosHttp({
				url: `api/Report/GetFuelEuMrvPortStays?childReportId=${reportDetails?.ReportMstId}`,
				method: "GET",
			});

			if (EUMRVPortStaysData?.data?.data) {
				setLoading(false);
				setEUMRVData(
					roundNumericValues(EUMRVPortStaysData?.data?.data, 3)
				);
			} else if (EUMRVPortStaysData?.data) {
				setLoading(false);
				setEUMRVData(roundNumericValues(EUMRVPortStaysData?.data, 3));
			} else {
				setLoading(false);
				setEUMRVData([]);
			}
		} catch (error) {
			setLoading(false);
			console.error(error);
		}
	};


	useEffect(() => {
		fetchEUMRVPortStayssData();
	}, []);

	return (
		<>
			{loading ? (
				<div className="loader">
					<Loader />
				</div>
			) : (
				<>
					{data && data?.reportView === "2.0" ? (
						<>
							<EmissionReported
								data={data?.portStayList || []}
								loading={loading}
							/>

							<div className="mt-4">
								<Button
									startIcon={
										<Icon
											icon={
												isExpanded
													? "keyboard_arrow_up"
													: "keyboard_arrow_down"
											}
										/>
									}
									className="icon-gap"
									onClick={toggleExpandCollapse}
								>
									{!isExpanded
										? "Show Details"
										: "Hide Details"}
								</Button>
							</div>

							{isExpanded && (
								<>
									<DerogationCCSandCCU
										data={data?.derogationCcs || []}
										loading={loading}
									/>
									<DerogationOMR
										data={data?.derogationPorts || []}
										loading={loading}
									/>
									<DerogationIceClass
										data={data?.derogationIceClasses || []}
										loading={loading}
									/>
									<DerogationPhaseIn
										data={
											data?.derogationReportingYears || []
										}
										loading={loading}
									/>
								</>
							)}

							<EmissionsAfterDerogation
								data={data?.emissionsAfterDerogations || []}
								loading={loading}
							/>
						</>
					) : (
						data &&
						data?.length > 0 &&
						data[0]?.reportView === "1.0" && (
							<EUMRVPortStaysOld
								data={data || []}
								loading={loading}
							/>
						)
					)}
				</>
			)}
		</>
	);
};
export default EUMRVPortStays;
